import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = ["placeholder", "onKeydown"]
const _hoisted_4 = { class: "search-input__button" }

import { ref, watch } from "vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import dictionary from "@/i18n/dictionary.json";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSearchInput',
  props: {
  onSubmit: {
    type: Function,
    required: true,
  },
  isPopupOpen: {
    type: Boolean,
    required: true,
  },
  onCloseClick: {
    type: Function,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: {
  "update:modelValue": (query: string | undefined) => {
    if (query) {
      return true;
    }
    return false;
  },
  search: (query: string | undefined) => {
    if (query) {
      return true;
    }
    return false;
  },
  focus: () => true,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  enter: (term: string) => true,
},
  setup(__props, { emit }) {

const props = __props;

const $t = useI18n().t;


const queryInputPlaceholder = $t(dictionary.search.placeholder[window.tressSite.toLowerCase()]);
const internalModel = ref<string>(props.modelValue);
watch(internalModel, (currVal: string | undefined) => {
  emit("update:modelValue", currVal);
  props.onSubmit(currVal);
});
watch(props, (currVal) => {
  internalModel.value = currVal.modelValue;
});
const onFocus = () => {
  emit("focus");
};
const onSubmit = (ev: Event) => {
  const formData = new FormData(ev.target as HTMLFormElement);
  const query = formData.get("query");
  props.onSubmit(query);
};
const onCloseClick2 = () => {
  props.onCloseClick();
};
const onEnter = (ev: KeyboardEvent) => {
  emit("enter", (ev.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "search-input__form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalModel).value = $event)),
        placeholder: _unref(queryInputPlaceholder),
        autocapitalize: "off",
        autocomplete: "off",
        autocorrect: "off",
        role: "combobox",
        spellcheck: "false",
        class: "search-input__input",
        name: "query",
        onFocus: onFocus,
        onKeydown: _withKeys(_withModifiers(onEnter, ["prevent"]), ["enter"])
      }, null, 40, _hoisted_3), [
        [_vModelText, internalModel.value]
      ]),
      _createElementVNode("button", _hoisted_4, [
        _createVNode(IconSearch, { class: "search-input__icon" })
      ])
    ], 40, _hoisted_2),
    (__props.isPopupOpen)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass([{ 'search-input__close-button--open': __props.isPopupOpen }, "search-input__close-button"]),
          onClick: onCloseClick2
        }, [
          _createVNode(_component_icon_close, { class: "search-input__close-icon" })
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})